var ReviewReportsActionsModalController = /** @class */ (function () {
    function ReviewReportsActionsModalController() {
    }
    ReviewReportsActionsModalController.prototype.$onInit = function () {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.assessmentInfo = this.resolve.assessmentInfo;
        this.reportUrl = 'api/candidate/candidatepdfreport?testinvitationid=' + this.assessmentInfo.testInvitationId + '&sectional=false';
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    ReviewReportsActionsModalController.prototype.refresh = function () {
        this.callbackObject.callbackType = "refresh";
        this.closeModal(this.callbackObject);
    };
    ReviewReportsActionsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    ReviewReportsActionsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return ReviewReportsActionsModalController;
}());
// import * as TEMPLATE from './review-reports-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./review-reports-actions-modal.html';
export var ReviewReportsActionsModalComponent = {
    selector: 'reviewReportsActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ReviewReportsActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/reports/reviewReports/reviewReportsActionsModal/review-reports-actions-modal.html'
    }
};
//# sourceMappingURL=review-reports-modal.component.js.map